import { render, staticRenderFns } from "./shouhuo.vue?vue&type=template&id=48d50bf5&scoped=true"
import script from "./shouhuo.vue?vue&type=script&lang=js"
export * from "./shouhuo.vue?vue&type=script&lang=js"
import style0 from "./shouhuo.vue?vue&type=style&index=0&id=48d50bf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d50bf5",
  null
  
)

export default component.exports